import { z } from "zod";

export const statusUpdateScopeSchema = z.discriminatedUnion("type", [
    z.object({ type: z.literal("days"), days: z.number() }),
    z.object({ type: z.literal("since_last_update") }),
    z.object({ type: z.literal("since_project_start") }),
    z.object({ type: z.literal("custom"), startDate: z.string(), endDate: z.string() }),
]);
export type StatusUpdateScope = z.infer<typeof statusUpdateScopeSchema>;

const statusUpdateUiContextSchema = z.object({
    type: z.literal("status-update"),
    scope: statusUpdateScopeSchema,
});
export type StatusUpdateUiContext = z.infer<typeof statusUpdateUiContextSchema>;

export const projectChatUiContextSchema = z
    .discriminatedUnion("type", [
        z.object({ type: z.literal("workstream"), id: z.string() }),
        z.object({
            type: z.literal("deliverable"),
            workstreamId: z.string(),
            id: z.string(),
        }),
        z.object({ type: z.literal("meetings") }),
        z.object({ type: z.literal("project-history") }),
        statusUpdateUiContextSchema,
    ])
    .nullable();

export type ProjectChatUiContext = z.infer<typeof projectChatUiContextSchema>;
